let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("9puKt")).then(() => parcelRequire('7UFNY'));